import React, { useState } from 'react';
import { Image } from '@chakra-ui/react';
import { Box, CloseButton, Flex, BoxProps } from '@chakra-ui/react';
import isotipoSvg from 'assets/svg/isotipo.svg';
import logoSvg from 'assets/svg/logo.svg';
import { isDev } from 'utils/functions';
import { NavBtn } from '../NavButtons';

const exampleContent = [
  {
    name: 'Cards',
    path: '/exemplos/cards',
  },
  {
    name: 'Componentes',
    path: '/exemplos/componentes',
  },
  {
    name: 'Graficos',
    path: '/exemplos/graficos',
  },
  {
    name: 'Tabelas',
    path: '/exemplos/tabelas',
  },
];

const dropContent = [
  {
    name: 'Modelos',
    path: '/relatorios/modelos',
  },
  {
    name: 'Distribuição da Frota',
    path: '/relatorios/distdefrotas',
  },
  {
    name: 'Manutenção',
    path: '/manutencao',
    insideDrops: [
      {
        name: 'Entrada e Saída',
        path: '/relatorios/manutencao/entradasaida',
      },
      { name: 'Serviços', path: '/relatorios/manutencao/servicos' },
    ],
  },
];

interface SidebarProps extends BoxProps {
  onClose: () => void;
  isCollapsed: boolean;
  sideBarName: string;
}

interface optionProps {
  fp: string[];
  sp: string[];
  tp: string[];
}
export const SidebarContent = ({
  onClose,
  isCollapsed,
  sideBarName,
  ...rest
}: SidebarProps) => {
  const [option, setOption] = useState<optionProps>({
    fp: ['home'],
    sp: [],
    tp: [],
  });

  return (
    <Box
      zIndex={10}
      bg="button"
      w={{ base: 'full', xl: isCollapsed ? '86px' : '248px' }}
      pos="fixed"
      h="full"
      px="16px"
      pt="44px"
      transition="ease-in-out 0.3s"
      overflowY={isCollapsed ? 'visible' : 'scroll'}
      sx={{
        '::-webkit-scrollbar': {
          display: 'none',
        },
      }}
      {...rest}
    >
      <Flex justifyContent="space-between" mb="34px" alignItems="center">
        <Image pl="8px" src={isCollapsed ? isotipoSvg : logoSvg} w="100px" />
        <CloseButton
          data-cy={`close-${sideBarName}`}
          display={{ base: 'flex', xl: 'none' }}
          onClick={onClose}
        />
      </Flex>

      <NavBtn
        onClose={onClose}
        isCollapsed={isCollapsed}
        option={option}
        setOption={setOption}
        name="Início"
        path="/inicio"
      />
      <NavBtn
        onClose={onClose}
        isCollapsed={isCollapsed}
        option={option}
        setOption={setOption}
        name="Relatórios"
        isDropable
        dropContent={dropContent}
        path="/relatorios"
      />
      <NavBtn
        onClose={onClose}
        isCollapsed={isCollapsed}
        option={option}
        setOption={setOption}
        name="Agendamentos"
        path="/agendamentos"
      />
      <NavBtn
        onClose={onClose}
        isCollapsed={isCollapsed}
        option={option}
        setOption={setOption}
        name="Vamos Controle"
        path="https://www.vamoscontrole.com.br/iweb2/loginvamoscontrole.aspx"
      />
      {isDev() && (
        <NavBtn
          onClose={onClose}
          isCollapsed={isCollapsed}
          option={option}
          setOption={setOption}
          name="Exemplos"
          isDropable
          dropContent={exampleContent}
          path="/examples"
        />
      )}
    </Box>
  );
};
